module.exports = __webpack_public_path__ + "img/1535512293.26374d82.jpg";